import { render, staticRenderFns } from "./UsersAdd.vue?vue&type=template&id=44cb8e04&scoped=true"
import script from "./UsersAdd.vue?vue&type=script&lang=js"
export * from "./UsersAdd.vue?vue&type=script&lang=js"
import style0 from "./UsersAdd.vue?vue&type=style&index=0&id=44cb8e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb8e04",
  null
  
)

export default component.exports